import { Button, ButtonProps } from "@mui/material";

interface StyledButtonProps extends ButtonProps {
  variant?: "contained" | "outlined";
}

export default function StyledButton({
  variant = "contained",
  sx = [], 
  children,
  ...props
}: StyledButtonProps) {
  const isOutlined = variant === "outlined";

  return (
    <Button
      variant={variant}
      sx={[
        (theme: any) => ({
          textTransform: "none",
          borderRadius: "20px", 
          height: "40px",
          px: 2.5,
          whiteSpace: "nowrap",
          boxShadow: "none",

          ...(isOutlined
            ? {
                backgroundColor: theme.palette?.common?.white || "#fff",
                color: theme.palette?.text?.primary || "#223354",
                fontSize: "0.85rem",
                fontWeight: 600,
                borderColor: theme.colors?.tableBorder || "rgba(148,163,184,0.35)",
                "&:hover": {
                  borderColor: theme.palette?.info?.main || "#33C2FF",
                  backgroundColor: theme.palette?.common?.white || "#fff",
                  boxShadow: "none",
                },
              }
            : {
                backgroundColor: theme.palette?.primary?.main || "#073857",
                color: theme.palette?.common?.white || "#ffffff",
                fontSize: "0.85rem",
                fontWeight: 500,
                "&:hover": {
                  backgroundColor: theme.palette?.primary?.dark || "#000C57",
                  boxShadow: "none",
                },
                "&:disabled": {
                  backgroundColor: theme.colors?.disabledBorder || "#908F8F",
                  color: theme.colors?.disabledWhite || "#F1FFFD",
                },
              }),
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    >
      {children}
    </Button>
  );
}